var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable, action } from 'mobx';
import { serializable } from 'serializr';
export default class LayoutStore {
    constructor() {
        this.sidebarPanel = LayoutStore.SIDEBAR_DEFAULT;
        this.editorAndCtxPanel = LayoutStore.EDITOR_CTX_DEFAULT;
        this.editorPanel = LayoutStore.EDITOR_DEFAULT;
    }
    toggleSize(panel) {
        switch (panel) {
            case 'sidebar': return this.toggleSidebar();
            case 'editor': return this.toggleEditor();
            case 'context': return this.toggleContext();
            case 'console': return this.toggleConsole();
        }
    }
    toggleSidebar() {
        if (this.sidebarPanel === '100%') {
            this.sidebarPanel = '15%';
        }
        else {
            this.sidebarPanel = '100%';
        }
    }
    toggleEditor() {
        if (this.editorPanel === '100%') {
            this.editorPanel = '65%';
        }
        else {
            this.editorPanel = '100%';
        }
    }
    toggleContext() {
        if (this.editorPanel === 0) {
            this.editorPanel = '65%';
        }
        else {
            this.editorPanel = 0;
        }
    }
    toggleConsole() {
        if (this.editorAndCtxPanel === 0) {
            this.editorAndCtxPanel = '75%';
        }
        else {
            this.editorAndCtxPanel = 0;
        }
    }
    reset(key) {
        switch (key) {
            case 'sidebarPanel':
                this.sidebarPanel = LayoutStore.SIDEBAR_DEFAULT;
                break;
            case 'editorAndCtxPanel':
                this.editorAndCtxPanel = LayoutStore.EDITOR_CTX_DEFAULT;
                break;
            case 'editorPanel':
                this.editorPanel = LayoutStore.EDITOR_DEFAULT;
                break;
        }
    }
}
LayoutStore.SIDEBAR_DEFAULT = '15%';
LayoutStore.EDITOR_CTX_DEFAULT = '75%';
LayoutStore.EDITOR_DEFAULT = '60%';
__decorate([
    observable, serializable,
    __metadata("design:type", Object)
], LayoutStore.prototype, "sidebarPanel", void 0);
__decorate([
    observable, serializable,
    __metadata("design:type", Object)
], LayoutStore.prototype, "editorAndCtxPanel", void 0);
__decorate([
    observable, serializable,
    __metadata("design:type", Object)
], LayoutStore.prototype, "editorPanel", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LayoutStore.prototype, "toggleSize", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], LayoutStore.prototype, "toggleSidebar", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], LayoutStore.prototype, "toggleEditor", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], LayoutStore.prototype, "toggleContext", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], LayoutStore.prototype, "toggleConsole", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], LayoutStore.prototype, "reset", null);
